import React from 'react'

import './styles/Main.scss'

import imgTwo from "../../assets/images/block-img-two.svg";
import imgThree from "../../assets/images/block-img-three.svg";
import imgFour from "../../assets/images/block-img-four.svg";
import imgFive from "../../assets/images/block-img-five.svg";
import imgSix from "../../assets/images/block-img-six.svg";
import Benefits from "../../components/Benefits";
// import imTwo from "../../assets/images/comp_process.svg";
import imTwo from "../../assets/images/handshake_monochromatic.svg";
import Preloader from "../../components/Preloader";
import {Link} from "react-router-dom";
import telegramLogo from "../../assets/images/telegram-logo.svg";
import { publicConfiguration } from '../../config';

export default class About extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            infoComp: {
                title: 'Контакты',
                desc: <div className="benefits--contact--container">
                    <h3>
                        Вы можете с нами связаться через:
                    </h3>
                    <div className="contacts__channels">
                        <a
                            className="contacts__channel-button"
                            href={`mailto:${publicConfiguration.supportEmail}`}
                            aria-label={`Написать на e-mail ${publicConfiguration.supportEmail}`}
                        >
                            {publicConfiguration.supportEmail}
                        </a>
                        <a
                            className="contacts__channel-button contacts__channel-button--telegram"
                            href="https://t.me/landlix_support_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Написать Landlix в Telegram: @landlix_support_bot"
                        >
                            <img
                                src={telegramLogo}
                                alt=""
                                aria-hidden="true"
                            />
                            <span>@landlix_support_bot</span>
                        </a>
                    </div>
                </div>,
                img: imTwo,
                data: '/about-us'
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        let { menu, menuActive } = this.state;
        return (
            <React.Fragment>
                <Preloader
                    preloader={true}
                    text={'Мы ответим в течении 10 минут.'}
                />
                <div
                    className="about"
                    style={{
                        paddingTop: '10vw'
                    }}
                >
                    {/*<div className="about__container">*/}
                        {/*<div className="about__block">*/}
                            {/*<div className="about__block__box">*/}
                                {/*<div className="about__block__box__title">*/}
                                    {/*Динамически развивающиеся копания*/}
                                {/*</div>*/}
                                {/*<div className="about__block__box__desc">*/}
                                    {/*Высококвалифицированная команда развивает каждый проект, делая его и последующии проекты лучшим на рынке.*/}
                                    {/*С нами успешно продолжают сотрудничать после релиза проекта.*/}
                                    {/*Каждый в нашей команде имеет опыт работы в своей сфере более 5 лет.*/}
                                    {/*У нас работают только лучшие специалисты и мы используюем только лучшие и передовые технологии.*/}
                                    {/*Заказать у нас разработку сайта — это увеличть конверсию продукта.*/}
                                    {/*Благодаря индивидуальному подходу и высокому качеству работы нашей команды — мы сумарно увеличили конверсию нашим заказчикам на более чем 10 000%.<br/>*/}
                                    {/**/}
                                {/*</div>*/}
                            {/*</div>*/}
                            {/*/!*<div className="about__block__box">*!/*/}
                                {/*/!*<div className="about__block__box--img">*!/*/}
                                    {/*/!*<img src={imgOne}/>*!/*/}
                                {/*/!*</div>*!/*/}
                            {/*/!*</div>*!/*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    <Benefits
                        data={this.state.infoComp}
                        blockLeft={false}
                    />
                </div>
            </React.Fragment>
        )
    }
}
